import React from 'react'

function Preview() {
  return (
    <span className="preview-svg-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        style={{
          fill: '#fff',
        }}
      >
        <path d="M 14 9 L 37 21 L 14 33 Z" />
        <rect
          width="47"
          height="38"
          x="2"
          y="2"
          ry="2"
          fill="none"
          stroke="#fff"
          strokeWidth="0.75"
        />
        <rect width="27" height="1.5" x="12" y="45" ry="1" />
      </svg>
    </span>
  )
}

export default Preview
